

import Modal from '../modal/index';


export default {
    /*
    * 请求第三方登录
    * */
    request: function () {

        let logindata = {
            "autoResize": false,
            "agentPageUrl": self.location.origin + '/loginagent.html',
            "callBack": "loginok",
            "redirectUrl": self.location.href,
            "data": {
                "domainName": "roadshow.eastmoney.com",
                "deviceType": "web",
                "productType": "emlive",
                "version": "16.0.0"
            }
        };

        // 通行证接口地址
        let loginurl = '//exaccount2.eastmoney.com/Home/Login?request=' + encodeURIComponent(JSON.stringify(logindata));
        let loginhtml = '<iframe id="loginframe" frameborder="0" width="360" height="460" src=' + loginurl + '></iframe>';

        let loginmodal = new Modal({
            content: loginhtml,
            showtitle: false
        });

        loginmodal.show();

        (<any>window).loginok = function () {
            window.location.reload();
        };
    },
    onLoginBefore: function () {
        self.location.reload();
    }
}